export const mapData = (data) => {
    if (!data || !Array.isArray(data.records)) {
        return []; 
    }

    return data.records.map(record => ({
        id: record.id,
        titel: record.titel,
        untertitel: record.untertitel,
        cover: record.cover,
        coverabbildungen: record.coverabbildungen,
        isbn: record.ean,
        ean: record.ean,
        preis: record.euro_d,
        verlag: record.verlag,
        autor: record.autor,
        herausgeber: record.herausgeber,
        erscheinungsdatum: record.datum_erscheinungstermin_yyyymmdd,
        formatangaben: record.formatangaben,
        format: record.format,
        produktform: record.produktform,
        pdf: record.pdf,
        audio: record.audio,
        video: record.video,
        vormerker: record.vormerker,
        themen: record.themen, 
        themen_bezeichnungen: record.themen_bezeichnungen, 
        themen_liste: record.themen_liste,
        sprache: record.produktsprache,
        illustration: record.illustrator,
        umbreitnummer: record.titelnummer_umbreitnummer,
        rang: record.rang,
        rabatt: record.rabatt,
        produktgruppe: record.produktgruppe,
        meldetext: record.meldetext,
        meldenummer_meldetext: record.meldenummer_meldetext,
        preisNX: record.euro_d, //für WK als preisNX (nexus) da aus derWK Tabelle ein falscher Preis kommt
        remissionsrecht: record.remissionsrecht,
        remissionsrecht_zusatz: record.remissionsrecht_zusatz,
        mwst_wert: record.mwst_wert
    }));
};



